import { render, staticRenderFns } from "./paiqian.vue?vue&type=template&id=67ad5a99&scoped=true"
import script from "./paiqian.vue?vue&type=script&lang=js"
export * from "./paiqian.vue?vue&type=script&lang=js"
import style0 from "./paiqian.vue?vue&type=style&index=0&id=67ad5a99&prod&scoped=true&lang=css"
import style1 from "./paiqian.vue?vue&type=style&index=1&id=67ad5a99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad5a99",
  null
  
)

export default component.exports